// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper__cT41y","bubble":"Tooltip_bubble__o9EYN"};